export const DASHBOARD = 'dashboard';

export type DashboardState = {
  isAdjusting: boolean;
};
